//
//
//
//

import { Wishlist } from '@/scripts/libs/analytics/wishlist'
import { EVENTS } from '@/scripts/constants/css-classes'
import { CART_SAVED, MINIWISHLIST_SAVED } from '@/scripts/constants/cookies'
import { Cookies } from '@/scripts/libs/cookies'
import wcs from '@/scripts/libs/wcs'
import { mapActions } from 'vuex'
import { ACTION_LOAD_MINICART, ACTION_LOAD_MINIWISHLIST } from '@/scripts/store/actions'

export default {
  name: 'rb-pcp-add-to-bag-trigger',
  mounted() {
    document.addEventListener(EVENTS.ADD_TO_BAG, this.onAddToBag)
  },
  beforeDestroy() {
    document.removeEventListener(EVENTS.ADD_TO_BAG, this.onAddToBag)
  },
  methods: {
    ...mapActions({
      loadCart: ACTION_LOAD_MINICART,
      loadWishlist: ACTION_LOAD_MINIWISHLIST,
    }),
    async onAddToBag(param) {
      if (param && param.detail && param.detail.isAddToBagFromMySelection) {
        if (param.detail.catEntryId1) {
          Wishlist.trackAddToCartFromMySelectionsBothProducts(
            this.$ma,
            this.itemsWishlist,
            param.detail.catEntryId1,
            param.detail.catEntryId2
          )
        } else if (param.detail.catEntryId) {
          Wishlist.trackAddToCartFromMySelections(
            this.$ma,
            this.itemsWishlist,
            param.detail.catEntryId
          )
        }
      }
      Cookies.remove(CART_SAVED)
      await this.loadCart()
      Cookies.remove(MINIWISHLIST_SAVED)
      await this.loadWishlist()
      if (param?.detail?.withRedirectToCart) {
        window.location.href = wcs.getEndPoint('shopCartView')
      }
    },
  },
}
